import { DateUtils, HotelRoomUtils } from '../../utils';
import { HotelStandalonePaxRestrictionPropsDefault } from '../../models';
import { HotelStandaloneRoomParams } from './composeHotelStandaloneRoomParams';
import { CampaignParams } from './composeCampaignParams';
import { SearchByPropertyParamsByRegion } from './composeSearchByPropertyParamsByRegion';
import { FilterParams } from './composeFilterParams';
import { AstIdParam } from './composeAstIdParam';

export const composeHotelStandaloneByRegionParams = ({
    segments = [],
    rooms = [],
    chainFilter,
    astId,
    searchId,
    buyPath = null,
    searchExtensionParam
}) => {
    const { type, id, regionType = null } = segments[0].destination;
    const limitRooms = HotelRoomUtils.getRoomsAvailableByRestrictions(
        rooms,
        HotelStandalonePaxRestrictionPropsDefault,
    );

    const searchParams = `checkIn=${DateUtils.toString(segments[0].date)}`
        .concat(`;checkOut=${DateUtils.toString(segments[1].date)}`)
        .concat(type && id ? `;geoId=${id}+${type}` : '')
        .concat(`${HotelStandaloneRoomParams.compose(limitRooms)}`)
        .concat(`${CampaignParams.compose()}`)
        .concat(searchId ? `;searchId=${searchId}` : '')
        .concat(buyPath ? `;buyPath=${buyPath}` : '')
        .concat(regionType ? `;regionType=${regionType}` : '')
        .concat(';internalSearch=true')
        .concat(searchExtensionParam);

    const accommodationParam = SearchByPropertyParamsByRegion.compose(type, id);
    const filtersParam = FilterParams.compose({ chain: chainFilter });
    const astIdParam = AstIdParam.compose({ astId });
    const queryParams = [accommodationParam, filtersParam, astIdParam].filter(Boolean).join('&');

    return queryParams.length === 0
        ? `${searchParams}`
        : `${searchParams}?${queryParams}`;
};
